import { render, staticRenderFns } from "./CompleteRegister.vue?vue&type=template&id=a4790a5a"
import script from "./CompleteRegister.vue?vue&type=script&lang=js"
export * from "./CompleteRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports